// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"19351":"a5ce6a92","79424":"2a7a80c1"}[chunkId] || chunkId) + "." + {"17603":"fade9775df38006b","17655":"666c6fe375c0d56d","19351":"939350935aef4943","48020":"238cce13fc376ff6","52146":"9e911aa91ec93faa","53348":"e1b6965ec9896ac3","79424":"0a792accd1ec49bd","84383":"9b8495ab458b91b2"}[chunkId] + ".js";
};